import { FC } from 'react';

import { useContractEditStore } from 'page/CustomerPage/hooks';
import { DeleteModalView } from 'page/CustomerPage/components/ContractEditModal/DeleteModalView';

type Props = {
  handleClose: () => void;
  handleClickGoInput: () => void;
  handleClickDelete: () => void;
};

export const DeleteModal: FC<Props> = ({
  handleClose,
  handleClickGoInput,
  handleClickDelete,
}) => {
  const { menuName, isOpenDeleteModal } = useContractEditStore();

  return (
    <>
      {/* 削除モーダル */}
      <DeleteModalView
        isOpen={isOpenDeleteModal}
        name={menuName}
        handleClose={handleClose}
        handleClickGoInput={handleClickGoInput}
        handleClickDelete={handleClickDelete}
      />
    </>
  );
};
